/**
 * @generated SignedSource<<86f8832f8e1ff30bccbc0c7bea19c2f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_viewer$data = {
  readonly favorableShipping: boolean | null;
  readonly " $fragmentType": "PdpSharedDetailShipping_viewer";
};
export type PdpSharedDetailShipping_viewer$key = {
  readonly " $data"?: PdpSharedDetailShipping_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_viewer",
  "selections": [
    {
      "alias": "favorableShipping",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "favorableShipping"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"favorableShipping\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c429f0916a6300c1864ae1cacef344a7";

export default node;
